export default "__VITE_ASSET__DEXqy5lh__"